import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Info } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { bcIcon } from '../lib/businessCategories';

// Slugify a Business Category name for stable data-testid values.
const bcSlug = (bc) => (bc || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default function Categories() {
  const { seller } = useAuth();
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    // Feb 2026: the Categories screen shows the seller's Business Categories
    // directly — never expanded into master-category sub-types. `cats` holds
    // an array of BC name strings, e.g. ["Fabric","Ladies Wear",...].
    setCats(seller?.business_categories || []);
    setLoading(false);
  }, [seller]);

  return (
    <div className="space-y-5 fade-up" data-testid="categories-page">
      <div className="fab-card p-4 flex items-start gap-3 border-l-4 border-fab-primary bg-fab-primary-lighter/40">
        <Lock className="w-5 h-5 text-fab-primary shrink-0 mt-0.5" />
        <div className="text-[12px] text-fab-text">
          <div className="font-semibold text-fab-text">Your business categories</div>
          <div className="text-fab-text-secondary mt-0.5">
            These are the categories you selected during onboarding. Click any card to view products in that category.
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-fab-text-muted text-[13px]">Loading...</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {cats.map((c) => (
            <button
              key={c}
              data-testid={`category-card-${bcSlug(c)}`}
              onClick={() => nav(`/dashboard/products?business_category=${encodeURIComponent(c)}`)}
              className="fab-card p-5 text-left hover:shadow-md hover:border-fab-primary border-2 border-transparent transition-all group"
            >
              <div className="text-3xl mb-2">{bcIcon(c)}</div>
              <div className="font-display font-bold text-fab-text group-hover:text-fab-primary">{c}</div>
            </button>
          ))}
          {cats.length === 0 && (
            <div className="col-span-full text-center text-[13px] text-fab-text-muted py-12 flex items-center justify-center gap-2">
              <Info className="w-4 h-4" /> No business categories on file. Please contact support.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
